export var DEFAULT_MIN_WIDTH = 144;
export var NODE_ENV_DEV = 'development';
export var POPOVER_WIDTH_AUTO = 'auto';
export var POPOVER_WIDTH_FIT = 'fit';
export var DEFAULT_POPOVER_WIDTH = POPOVER_WIDTH_AUTO;